import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PlantDetailPage({ deviceId }) {
  const navigate = useNavigate();
  const { plantId } = useParams();

  return (
    <div className="px-5 pt-6 pb-4" data-testid="plant-detail-page">
      <div className="flex items-center gap-3 mb-6">
        <button onClick={() => navigate(-1)} data-testid="detail-back-btn" className="w-12 h-12 rounded-xl border-2 border-[#0A2918] flex items-center justify-center press-active hard-shadow-sm bg-white">
          <ArrowLeft size={24} strokeWidth={2.5} />
        </button>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#0A2918]" style={{ fontFamily: 'Work Sans' }}>
          Plant Details
        </h1>
      </div>
      <p className="text-base text-[#2A4D3B]">Plant ID: {plantId}</p>
    </div>
  );
}
